var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value || _vm.value === 0)?_c('v-list-item',{class:_vm.couleur},[_c('v-list-item-content',[_vm._v(_vm._s(_vm.name))]),_c('v-list-item-content',[_vm._v(_vm._s(_vm.value))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }